import type { SalesStage } from '../../../api';

/** Дней в этапе без контакта — оранжевый chip «застой» (синхрон с backend insights). */
export const CRM_STALE_DAYS = 3;

export const SALES_STAGE_ORDER: SalesStage[] = [
  'lead_received',
  'negotiation',
  'invoice_sent',
  'paid',
  'measurement',
  'measurement_done',
  'compose',
  'production',
  'ready_to_ship',
  'fulfillment',
  'lost',
];

export const SALES_STAGE_ORDER_ACTIVE: SalesStage[] = SALES_STAGE_ORDER.filter((s) => s !== 'lost');

export const SALES_STAGE_META: Record<
  SalesStage,
  { label: string; color: string; bg: string; border: string }
> = {
  lead_received: {
    label: 'Заявка',
    color: '#F6AD55',
    bg: 'rgba(246,173,85,0.15)',
    border: 'rgba(246,173,85,0.35)',
  },
  negotiation: {
    label: 'Сделка',
    color: '#63B3ED',
    bg: 'rgba(99,179,237,0.15)',
    border: 'rgba(99,179,237,0.35)',
  },
  invoice_sent: {
    label: 'Счёт',
    color: '#D6BCFA',
    bg: 'rgba(159,122,234,0.15)',
    border: 'rgba(159,122,234,0.35)',
  },
  paid: {
    label: 'Оплачено',
    color: '#68D391',
    bg: 'rgba(72,187,120,0.15)',
    border: 'rgba(72,187,120,0.35)',
  },
  measurement: {
    label: 'Замер',
    color: '#F6AD55',
    bg: 'rgba(246,173,85,0.18)',
    border: 'rgba(246,173,85,0.4)',
  },
  measurement_done: {
    label: 'После замера',
    color: '#63B3ED',
    bg: 'rgba(99,179,237,0.18)',
    border: 'rgba(99,179,237,0.38)',
  },
  compose: {
    label: 'Состав',
    color: '#D6BCFA',
    bg: 'rgba(159,122,234,0.16)',
    border: 'rgba(159,122,234,0.36)',
  },
  production: {
    label: 'Производство',
    color: '#B794F4',
    bg: 'rgba(159,122,234,0.18)',
    border: 'rgba(159,122,234,0.38)',
  },
  ready_to_ship: {
    label: 'Готов',
    color: '#68D391',
    bg: 'rgba(72,187,120,0.2)',
    border: 'rgba(72,187,120,0.45)',
  },
  fulfillment: {
    label: 'Выдача',
    color: '#63B3ED',
    bg: 'rgba(99,179,237,0.18)',
    border: 'rgba(99,179,237,0.4)',
  },
  lost: {
    label: 'Потеряна',
    color: '#A0AEC0',
    bg: 'rgba(160,174,192,0.12)',
    border: 'rgba(160,174,192,0.3)',
  },
};

export const ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'Ожидает',
  confirmed: 'В работе',
  in_production: 'В производстве',
  ready: 'Готов к выдаче',
  delivered: 'Закрыт · выдан',
  cancelled: 'Отменён',
};

export const CRM_TASK_KIND_LABELS: Record<string, string> = {
  call: 'Звонок',
  send_quote: 'КП',
  follow_up: 'Связаться',
  other: 'Другое',
};
